require('./club-map.jade')

class ClubMapCtrl
  constructor: (scope, @GoogleMapLoaderService) ->
    @GoogleMapLoaderService.load().then =>
      @mapOptions =
        center: new google.maps.LatLng(scope.$parent.clubInfo.loc[0], scope.$parent.clubInfo.loc[1])
        zoom: 15
        mapTypeId: google.maps.MapTypeId.ROADMAP

ClubMapCtrl.$inject = [
  '$scope'
  'GoogleMapLoaderService'
]

module.exports = ClubMapCtrl



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/club/club-map/club-map-controller.coffee